import { useState } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { datePickerFormat } from 'helpers';
import { EstateResultItem_OneViewAddressInput } from 'queries';

type Props = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  setEssentialData: Function;
};

const useStyles = makeStyles(() => ({
  addressContainer: {
    paddingTop: '10px',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
  },
  container: {
    paddingTop: '10px',
  },
  dateInputContainer: {
    paddingTop: '10px',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  inputField: {
    textAlign: 'left',
    width: '100%',
  },
  title: {
    paddingTop: '10px',
  },
}));

export default function AddAddressItem({ setEssentialData }: Props) {
  const classes = useStyles();
  const [addressInput] = useState<EstateResultItem_OneViewAddressInput>({
    addressType: '',
    houseNumber: '',
    streetName: '',
    streetType: '',
    cityName: '',
    stateAbbreviation: 'N/A',
    zipCode: '',
    dateFirstReported: '',
    dateLastReported: '',
  });

  const [selectedDateFirstReported, setSelectedDateFirstReported] = useState<Date>();
  const [selectedDateLastReported, setSelectedDateLastReported] = useState<Date>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleInputChange = (e: any) => {
    const name: string = e.target.name;
    addressInput[name as keyof EstateResultItem_OneViewAddressInput] = e.target.value;
    setEssentialData(addressInput);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDateChange = (e: any, name: string) => {
    const date = new Date(e);
    const formattedDate = `${date.getMonth() + 1 < 10 ? '0' : ''}${date.getMonth() + 1}/${
      date.getDate() < 10 ? '0' : ''
    }${date.getDate()}/${date.getFullYear()}`;
    addressInput[name as keyof EstateResultItem_OneViewAddressInput] = formattedDate;
    if (name === 'dateFirstReported') {
      setSelectedDateFirstReported(e);
    } else {
      setSelectedDateLastReported(e);
    }
    setEssentialData(addressInput);
  };

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Add Address History
      </Typography>
      <Grid className={classes.container}>
        <TextField
          className={classes.inputField}
          fullWidth
          name="houseNumber"
          label="Address"
          variant="outlined"
          autoFocus
          onChange={handleInputChange}
          inputProps={{ maxLength: 50 }}
        />
      </Grid>

      <Grid className={classes.addressContainer}>
        <Grid>
          <TextField
            className={classes.inputField}
            fullWidth
            name="cityName"
            label="City"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 30 }}
          />
        </Grid>
        <Grid>
          <TextField
            className={classes.inputField}
            fullWidth
            name="stateAbbreviation"
            label="State"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 2 }}
          />
        </Grid>
        <Grid>
          <TextField
            className={classes.inputField}
            fullWidth
            name="zipCode"
            label="Zip Code"
            variant="outlined"
            autoFocus
            onChange={handleInputChange}
            inputProps={{ maxLength: 5 }}
          />
        </Grid>
      </Grid>
      <Grid className={classes.container}>
        <TextField
          className={classes.inputField}
          fullWidth
          name="addressType"
          label="Type (Current / Former)"
          variant="outlined"
          autoFocus
          onChange={handleInputChange}
          inputProps={{ maxLength: 30 }}
        />
      </Grid>
      <Grid className={classes.dateInputContainer}>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption">Date First Reported</Typography>
          <DatePicker
            orientation="landscape"
            value={selectedDateFirstReported}
            maxDate={selectedDateLastReported}
            onChange={(e) => handleDateChange(e, 'dateFirstReported')}
            format={datePickerFormat}
            className={classes.inputField}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption">Date Last Reported</Typography>
          <DatePicker
            orientation="landscape"
            value={selectedDateLastReported}
            minDate={selectedDateFirstReported}
            onChange={(e) => handleDateChange(e, 'dateLastReported')}
            format={datePickerFormat}
            className={classes.inputField}
          />
        </Grid>
      </Grid>
    </>
  );
}
